import { Component, Input, OnInit } from '@angular/core';
import Windowsticker from '../../model/product/windowsticker/windowsticker';
import { DatePipe } from '@angular/common';
import WindowStickerPlacement from '../../model/product/windowsticker/windowsticker-placement';
import ProductHelper from '../../helpers/product-helper';
import { SubProject } from '../../model/project/sub-project';
import { StringHelper } from 'src/app/helpers/string-helper';
import { Project } from '../../model/project/project';
import Product from 'src/app/model/product/product';
import Board from 'src/app/model/product/board/board';
import BoardPlacement from 'src/app/model/product/board/board-placement';
import OtherProduct from 'src/app/model/product/other-product/other-product';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { DO_CHECK_DEBOUNCE_TIME } from 'src/globals/globals';
import { FileHelper } from '../../helpers/file-helper';

@Component({
  selector: 'product-placement-summary',
  templateUrl: './product-placement-summary.component.html',
  styleUrls: ['./product-placement-summary.component.scss'],
})
export class ProductPlacementSummaryComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  inputProduct: Product;
  @Input()
  inputProject: Project;
  @Input()
  inputSubProject: SubProject;
  @Input()
  index = 0;

  inputWindowSticker: Windowsticker;
  inputBoard: Board;
  boardPlacement: BoardPlacement;
  inputOtherProduct: OtherProduct;
  init = false;

  wetDisplay: string = '';
  insideDisplay: string = '';
  obstructionsDisplay: string = '';
  oldStickerDisplay: string = '';
  obstructionsOrOldStickerDisplay: string = '';
  isImage = FileHelper.isImage;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private datepipe: DatePipe
  ) {
    super();
  }

  ngOnInit() {
    if (
      ProductHelper.isWindowSticker(this.inputProduct) ||
      ProductHelper.isCustomWindowSticker(this.inputProduct)
    ) {
      this.inputWindowSticker = <Windowsticker>this.inputProduct;
      this.calculateWindowStickerDisplays();
      this.addSubscription(
        this.projectDisplayObservableService.getProductPlacementVariableChangedSubscribable(),
        () => {
          this.calculateWindowStickerDisplays();
        },
        () => {},
        DO_CHECK_DEBOUNCE_TIME
      );
    }
    if (ProductHelper.isBoard(this.inputProduct)) {
      this.inputBoard = <Board>this.inputProduct;
    }
    if (ProductHelper.isOtherProduct(this.inputProduct)) {
      this.inputOtherProduct = <OtherProduct>this.inputProduct;
    }
    this.init = true;
  }

  formatDate(date: Date) {
    return this.datepipe.transform(date, 'dd/MM/yyyy');
  }

  getWet() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    if (placement != null) {
      return placement.wet ? 'Nat' : 'Droog';
    }
  }

  getInside() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    if (placement != null) {
      return placement.inside ? 'Binnenkant' : 'Buitenkant';
    }
  }

  showObstructionsOldSticker() {
    if (this.inputWindowSticker.productPlacement == null) {
      return false;
    }
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    return (
      placement.windowObstacle != null || placement.oldStickerPresent != null
    );
  }

  getObstructionsOldSticker() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    let toJoin = [];
    if (placement.windowObstacle != null) {
      toJoin.push(
        placement.windowObstacle ? 'Er zijn obstakels' : 'Geen obstakels'
      );
    }
    if (placement.oldStickerPresent != null) {
      toJoin.push(
        placement.oldStickerPresent
          ? 'Er zijn oude stickers'
          : 'Geen oude stickers'
      );
    }
    return StringHelper.join(toJoin, ' / ');
  }

  getObstructions() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    if (placement != null) {
      return placement.windowObstacle;
    }
  }

  getOldSticker() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    if (placement != null) {
      return placement.oldStickerPresent;
    }
  }

  getOldStickerText() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    if (placement != null) {
      return placement.extraInfoOldStickerPresent;
    }
  }

  getObstructionsText() {
    let placement = <WindowStickerPlacement>(
      this.inputWindowSticker.productPlacement
    );
    if (placement != null) {
      return placement.extraInfoWindowObstacle;
    }
  }

  shortenName(name: string) {
    name = name.trim().replace(' ', '');
    let result = name.trim().replace(' ', '');
    let split = name.split('.');
    if (split.length > 1) {
      if (name.length > 8) {
        result =
          split[0].substring(0, 8 - split[split.length - 1].length) +
          '...' +
          split[split.length - 1];
      }
    }
    return result;
  }

  calculateWindowStickerDisplays() {
    this.wetDisplay = this.getWet();
    this.insideDisplay = this.getInside();
    this.obstructionsDisplay = this.getObstructions()
      ? this.getObstructionsText()
      : '';
    this.oldStickerDisplay = this.getOldSticker()
      ? this.getOldStickerText()
      : '';
    this.obstructionsOrOldStickerDisplay = this.showObstructionsOldSticker()
      ? this.getObstructionsOldSticker()
      : '';
  }

  getTypeTranslation(type, otherProductName) {
    return ProductHelper.getType(type, otherProductName);
  }

  stringNotEmpty(s: string): boolean {
    return !StringHelper.isEmpty(s);
  }
}
